'use client';

import {isError} from '@epic-mw/error-types';
import useSWRImmutable from 'swr/immutable';

import {useAccountId} from '../account';
import {API, getApiPath} from '@/lib/utils/api.utils';

export interface AOMPolicyRes {
	AOMFailed: boolean;
}

const getAOMPolicy = async (): Promise<AOMPolicyRes> => {
	try {
		const response = await API.get<{failed: boolean}>(`${getApiPath()}/policy/aom`);

		return {
			AOMFailed: response.data?.failed
		};
	} catch (err) {
		console.error('getAOMPolicy() failed to load', isError(err) && err.message);
		throw err;
	}
};

interface HookRes {
	result: AOMPolicyRes | undefined;
	isLoading: boolean;
	error: any;
}

export const useAccountAOMPolicy = (): HookRes => {
	const accountId = useAccountId();
	const shouldFetch = Boolean(accountId);

	const {data, error} = useSWRImmutable(shouldFetch ? `aom-${accountId}` : null, getAOMPolicy, {
		errorRetryCount: 0
	});

	return {
		result: data,
		isLoading: Boolean(!data && !error && shouldFetch),
		error
	};
};
